import { environment } from 'src/environments/environment';

/**
 * Design Tokens Lab is strictly for local / develop hosts.
 * Even if a non-prod build mistakenly enables the flag, QA/prod hosts stay blocked.
 */
export function isDesignTokensLabEnabled(): boolean {
    if (environment.production) {
        return false;
    }
    if (
        (environment as { designTokensLabEnabled?: boolean }).designTokensLabEnabled !== true
    ) {
        return false;
    }
    if (typeof window === 'undefined' || !window.location?.hostname) {
        return false;
    }
    return isDesignTokensLabHost(window.location.hostname);
}

export function isDesignTokensLabHost(hostname: string): boolean {
    const host = (hostname || '').trim().toLowerCase();
    if (!host) {
        return false;
    }
    if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0') {
        return true;
    }
    if (host === 'prestadores.dev.simfinix.com' || host.endsWith('.dev.simfinix.com')) {
        return true;
    }
    // LAN hosts used with `ng serve --host 0.0.0.0`
    if (/^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(host)) {
        return true;
    }
    return false;
}
